import {
  FilterOptionValue,
  FormulaVersionQueryValue,
  V53FlavorOptionValue,
  ProductOptionSkuKey,
  ProductOptionValue,
  SortByTypeQueryValue,
  SortOptionValue,
  SortOrderQueryValue,
  ReviewLabel,
  V53AGZFlavorOptionValue,
  FlavorTag
} from '@portal/types/review';

export const REVIEW_FILTER_VALUE_TO_FORMULA_VERSION_MAP: Record<
  FilterOptionValue,
  FormulaVersionQueryValue
> = {
  ag1: 'V52',
  'ag1-next-gen': 'V53',
  // TODO(AGZ): update proper value this once the API is updated
  'ag-vitamin-d3-k2': 'V53',
  'ag-omega3': 'V53',
  'ag-agz': 'AGZ',
  all: undefined
} as const;

export const REVIEW_SORT_VALUE_TO_SORT_ORDER_MAP: Record<SortOptionValue, SortOrderQueryValue> = {
  rating: 'desc',
  newest: 'desc',
  oldest: 'asc'
} as const;

export const REVIEW_SORT_VALUE_TO_SORT_BY_MAP: Record<SortOptionValue, SortByTypeQueryValue> = {
  rating: 'rating',
  newest: 'date',
  oldest: 'date'
} as const;

export const REVIEW_PRODUCT_OPTION_VALUE_TO_LABEL_MAP: Record<ProductOptionValue, string> = {
  'ag1-next-gen': 'AG1 Next Gen',
  ag1: 'AG1',
  'ag-vitamin-d3-k2': 'AG Vitamin D3+K2',
  'ag-omega3': 'AG Omega3',
  'ag-agz': 'AGZ'
} as const;

export const REVIEW_PRODUCT_FLAVOR_VALUE_TO_LABEL_MAP: Record<V53FlavorOptionValue, string> = {
  original: 'Original',
  tropical: 'Tropical',
  berry: 'Berry',
  citrus: 'Citrus',
  all: 'All'
} as const;

export const REVIEW_PRODUCT_FLAVOR_OPTION_VALUE_TO_SKU_MAP: Record<V53FlavorOptionValue, string> = {
  original: 'FG-20003',
  tropical: 'FG-20038',
  berry: 'FG-20058',
  citrus: 'FG-20059',
  all: 'all'
} as const;

export const REVIEW_PRODUCT_FLAVOR_OPTION_VALUE_TO_SKU_MAP_AGZ: Record<
  V53AGZFlavorOptionValue,
  string
> = {
  chocolate: 'FG-20043',
  'chocolate-mint': 'FG-20042',
  'mixed-berry': 'FG-20122',
  all: 'all'
} as const;

export const REVIEW_PRODUCT_OPTION_VALUE_TO_SKU_MAP: Record<ProductOptionSkuKey, string> = {
  ag1: 'GR10107US',
  'ag-vitamin-d3-k2': 'D310701',
  'ag-omega3': 'OM10105'
} as const;

export const REVIEW_PRODUCT_SKU_LIST: string[] = [
  'FG-20003',
  'FG-20038',
  'FG-20058',
  'FG-20059',
  'GR10107US',
  'D310701',
  'OM10105',
  'FG-20043',
  'FG-20042',
  'FG-20122'
] as const;

export const REVIEW_PRODUCT_SKU_TO_PRODUCT_TAG_MAP: Record<string, ReviewLabel> = {
  'FG-20003': 'AG1 Next Gen: Original',
  'FG-20038': 'AG1 Next Gen: Tropical',
  'FG-20058': 'AG1 Next Gen: Berry',
  'FG-20059': 'AG1 Next Gen: Citrus',
  GR10107US: 'AG1',
  D310701: 'AG Vitamin D3+K2',
  OM10105: 'AG Omega3',
  'FG-20043': 'AGZ: Chocolate',
  'FG-20042': 'AGZ: Chocolate Mint',
  'FG-20122': 'AGZ: Mixed Berry'
} as const;

export const REVIEW_PRODUCT_SKU_TO_FLAVOR_TAG_MAP: Record<string, FlavorTag> = {
  'FG-20003': 'Original',
  'FG-20038': 'Tropical',
  'FG-20058': 'Berry',
  'FG-20059': 'Citrus',
  'FG-20043': 'Chocolate',
  'FG-20042': 'Chocolate Mint',
  'FG-20122': 'Mixed Berry'
} as const;

export const REVIEW_PRODUCT_SKU_TO_FLAVOR_COLOR_MAP: Record<string, string> = {
  'FG-20003': '#023D3D',
  'FG-20038': '#E3BE38',
  'FG-20058': '#E5657E',
  'FG-20059': '#FF942A',
  'FG-20043': '#A57E63',
  'FG-20042': '#77C19A',
  'FG-20122': '#D057AB'
} as const;
